import React from 'react'
import { images } from 'theme'
import { useNavigate , useLocation} from "react-router-dom";
import { path } from 'utils/const'
import style from "../../pages/pendingApproval/pending.module.css";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import { FaCircle } from 'react-icons/fa';


const BackComponent = (props)=> {
  const {
    activeCount,
    title,
    dashboard,
    onNavigateBack,
    onNavigateToDashboard
  } = props
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const navigateBack = () => {
    if (onNavigateBack) {
      onNavigateBack()
    }
    navigate(-1);
  }
  const navigateToDashboard = ()=>{
    if (onNavigateToDashboard) {
      onNavigateToDashboard()
    }
    navigate(dashboard)
  }
  return (
  <div className={style.activeConsultation}>
    <div className="d-flex">
      <button type="button"  onClick={dashboard?navigateToDashboard :navigateBack}>
        <img src={images.backbutton} className={style.BackIcon} alt="logo"/>
      </button>
      <p className={style.bold}>{title}</p>
      {activeCount? <p className={style.RedColour}>({activeCount})</p>:<p></p>}
    </div>

    {(currentPath.includes("/activeconsultationpage") ||
      currentPath.includes("/pastconsultationpage")) && (
      <div className={style.status}>
        <div className={style.statusItem}>
          <FaCircle size={18} color="#58BD19" />
          <span className={style.approvedText}>Approved</span>
        </div>
        <div className={style.statusItem}>
          <FaCircle size={18} color="#EC4E4E" />
          <span className={style.declinedText}>Declined</span>
        </div>
      </div>
      )}
   
    {currentPath.includes("/consultation") && ( 
      <div className={style.statusIndicators}>
        <div className={style.statusItem}>
          <AiOutlineCheckCircle size={18} color="#58BD19" />
          <span className={style.approvedText}>Approved</span>
        </div>
        <div className={style.statusItem}>
          <AiOutlineCloseCircle size={18} color="#EC4E4E" />
          <span className={style.declinedText}>Declined</span>
        </div>
      </div>
      )}
  </div>
  )
}
export default BackComponent
